import { useTranslation } from "react-i18next";

import { IndicatorFrequencySelectDropdown } from "@/domain/indicator/components/indicator-frequency-select-dropdown";
import {
  type IndicatorFrequency,
  indicatorFrequencyFromString,
} from "@/domain/indicator/models/indicator-frequency-model";

import { SelectTriggerButton } from "./select-trigger-button";

interface FrequencySelectFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function FrequencySelectField({ value, onChange, disabled }: FrequencySelectFieldProps) {
  const { t } = useTranslation("indicator");
  const frequency: IndicatorFrequency | undefined = indicatorFrequencyFromString(value);
  const displayName = frequency ? t(`frequency.${frequency}`) : "";

  return (
    <IndicatorFrequencySelectDropdown
      defaultValue={frequency}
      onSelect={(next) => onChange(next ?? "")}
      isRequired={frequency !== undefined}
      asChild
    >
      <SelectTriggerButton value={displayName} disabled={disabled} />
    </IndicatorFrequencySelectDropdown>
  );
}
